import moment from "moment";

import { authHeader } from "../../../../../helpers/auth-header";
import { client } from "../../../../../actions";
import { message } from "antd";
import uri from "../../../constants/uri";

const editMainInfo = async (newVoting, savedVoting) => {
	try {
		await client.put(
			uri,
			{
				Id: savedVoting.id,
				TypeId: savedVoting.type.id,
				Title: newVoting.title,
				Text: newVoting.description,
				DateStart: moment(newVoting.period[0].format("YYYY-MM-DD[T]HH:mm:[00]")).utc().format(),
				DateStop: moment(newVoting.period[1].format("YYYY-MM-DD[T]HH:mm:[59]")).utc().format(),
			},
			{
				headers: authHeader(),
			}
		);
	} catch (e) {
		console.error(e);
		message.error(
			"Не получилось отредактировать основную информацию опроса, попробуйте позже"
		);
	}
};

export default editMainInfo;
